// extracted by css-extract-rspack-plugin
export default {"cls1":"Bookmarkers-cls1_sKl","cls2":"Bookmarkers-cls2_q-7 Bookmarkers-cls1_sKl"};